module.exports = __webpack_public_path__ + "static/logo_mobile-5ea16cd7603a8e858b740672242edaaf.svg";